import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormCheckableDisclosure } from '~/components/atoms/fields/CheckableDisclosure';
import { FormDateField } from '~/components/atoms/fields/DateField';

export type IArticleFormPublicationSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
};

export const ArticleFormPublicationSection: React.FC<
  IArticleFormPublicationSectionProps
> = ({ sx, form }) => {
  const { t } = useTranslation();

  return (
    <FormCheckableDisclosure
      sx={sx}
      label={t('ArticleFormPublicationSection.schedule-publication')}
      control={form.control}
      name="publicationScheduled"
      initiallyExpanded={!!form.watch('publishAt')}
    >
      <Labeled
        label={t('ArticleFormPublicationSection.publish-at')}
        disabled={!form.watch('publicationScheduled')}
        required
      >
        <FormDateField
          name="publishAt"
          control={form.control}
          defaultValue={new Date().toISOString()}
        />
      </Labeled>
    </FormCheckableDisclosure>
  );
};
